// Dev-only convenience: seed the auth store from VITE_DEV_ACCESS_TOKEN /
// VITE_DEV_REFRESH_TOKEN so the storefront can hit authenticated endpoints
// without going through the customer signup/login flow.
//
// Disabled in production builds (env.devAccessToken is null there).
// Skipped if a real session already exists, so a manual login isn't blown
// away on hot-reload.
import { useEffect } from 'react';
import { useAuthStore } from '@core/store/authStore';
import { env } from '@config/env';

export default function DevAuthBootstrap() {
  useEffect(() => {
    if (!env.devAccessToken) return;
    const existing = useAuthStore.getState();
    if (existing.accessToken) return;

    useAuthStore.getState().setSession({
      access_token: env.devAccessToken,
      refresh_token: env.devRefreshToken ?? '',
      token_type: 'Bearer',
      // Set an expires_in well in the future so the store doesn't try to
      // refresh; the real JWT exp guards the backend side.
      expires_in: 0,
      user: { user_id: 'dev', email: 'dev@local', role_id: '' },
    });

    if (import.meta.env.DEV) {
      console.info('[dev-auth] seeded auth store from VITE_DEV_ACCESS_TOKEN');
    }
  }, []);

  return null;
}
